export default {"src":"/_next/static/media/appstore-tv2-play.38298c97.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};